import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

import { deviceType } from "../../../../utils";

export const SectionTitle = styled.h3`
  margin: 0 0 16px;
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
`;

export const NoClaimsText = styled.p`
  margin: 0;
  font-size: ${fontSize.font14};
  color: ${theme.greyText};
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${deviceType.mobile} {
    flex-direction: row;
    gap: 12px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    margin: 0 -16px;
    padding: 0 16px 4px;
    scroll-padding-left: 16px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ClaimedCardWrapper = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  position: relative;

  @media ${deviceType.mobile} {
    flex: 0 0 82%;
    scroll-snap-align: start;
  }
`;

export const ClaimedCardContent = styled.div`
  padding: 16px;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const ClaimedCardTitle = styled.span<{ $color?: string }>`
  flex: 1;
  min-width: 0;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.black};
  color: ${({ $color }) => $color || theme.blackText};
`;

export const ClaimTypeTitle = styled.span<{ $color?: string }>`
  display: block;
  margin-top: 5px;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  color: ${({ $color }) => $color || theme.greyText3};
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  flex-shrink: 0;
  color: ${theme.blueText};

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const GradientBarContainer = styled.div`
  height: 4px;
  width: 100%;
  position: relative;
`;

export const GradientBarTrack = styled.div`
  position: absolute;
  inset: 0;
  background: ${theme.greyText10};
`;

export const GradientBar = styled.div<{
  $colors: string[];
}>`
  position: absolute;
  inset: 0;
  background: ${({ $colors }) =>
    `linear-gradient(to right, ${$colors.join(", ")})`};
`;
